import React from 'react';
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Voluntarias from '../../components/transferenciasestado/voluntarias';


function VoluntariasScreen() {
    return (
        <Fragment>
            <Head titulo="Transferências Estaduais Voluntárias" />
            <Header />
            <Container>
                <Voluntarias />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default VoluntariasScreen;